import { useMemo } from 'react';

const useExportUrl = (path: string): any => {
  const exportURL = useMemo(() => {
    const url: any = new URL(path, window.location.origin);

    // users should always see the full chart's tracks in csv
    url.searchParams.set('trackLimit', 999);

    // set the download query param to true
    url.searchParams.set('download', true);

    return url.toString();
  }, [path]);
  return exportURL;
};

export default useExportUrl;
